(()=>{
  "use strict";

  var generatePdf = (element) => {
    let doc = new jsPDF("p", "mm", "a4"), pos_x = 0, pos_y = 0;
    doc.text("Análisis FESP", 10, 10);
    doc.autoTable({ 
      html: '#level_development'
    });
    doc.addImage(document.getElementById("fesp_barchart").toDataURL(),"PNG", 10, 60, 180, 90);

    $("#charts_all_fesps canvas").each((idx, canvas) => {
      pos_x = idx % 2 == 0 ? 10 : 90;
      pos_y = 180 * (idx + 1);
      console.log(`x: ${pos_x} y: ${pos_y}`);
      doc.addImage(canvas.toDataURL(),"PNG", pos_x, pos_y, 90, 45);
    });

    doc.save();
  };

  document.addEventListener('turbolinks:load', () => {
    // $('.btn_generate_pdf').click((e) => {
    //   generatePdf($(e.currentTarget).data('body-pdf'));
    // });
  });
})();